import { LANGUAGE } from 'src/app/constants/configObjectProperties';
import { LANGUAGE_LOCALE_DEFAULT } from 'src/app/constants/language';
import { getConfig } from 'src/app/utils/config';

type Separator = ',' | '.';

export const getSeparators = (): { group: Separator; decimal: Separator } => {
  const locale = getConfig(LANGUAGE, LANGUAGE_LOCALE_DEFAULT);
  const parts = new Intl.NumberFormat(locale).formatToParts(1234567.89);
  return {
    group: (parts.find((p) => p.type === 'group')?.value ?? ',') as Separator,
    decimal: (parts.find((p) => p.type === 'decimal')?.value ??
      '.') as Separator,
  };
};

const getGroupSeparatorRegex = (groupSeparator: Separator) =>
  groupSeparator === ',' ? /,/g : /\./g;

const getDecimalSeparatorRegex = (decimalSeparator: Separator) =>
  decimalSeparator === '.' ? /\./g : /,/g;

const getDecimalSeparatorExceptFirstRegex = (decimalSeparator: Separator) =>
  decimalSeparator === '.' ? /(\..*)\./ : /(,.*),/;

const NUMBER_WITH_TWO_DECIMALS_REGEX = /([0-9]*\.[0-9]{2})([0-9]*)/;

export const normalizeNumber = (value: string): string => {
  const { group, decimal } = getSeparators();
  return value
    .trim()
    .replace(getGroupSeparatorRegex(group), '')
    .replace(getDecimalSeparatorRegex(decimal), '.')
    .replace(getDecimalSeparatorExceptFirstRegex(decimal), '$1');
};

export const parseNumber = (value: string): number => {
  if (value === '') {
    return NaN;
  }
  const normalizedValue = normalizeNumber(value).replace(
    NUMBER_WITH_TWO_DECIMALS_REGEX,
    '$1',
  );
  return Number(normalizedValue);
};
